import * as Avatar from '@givebutter/primitives/avatar';
import { faRepeat } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Tooltip from 'components/tooltip/Tooltip';
import { PolymorphicTransaction } from 'types/domain';

interface TransactionRecurringPlanBadgeProps {
    transaction: PolymorphicTransaction;
}

const TransactionRecurringPlanBadge = (props: TransactionRecurringPlanBadgeProps) => {
    const { transaction } = props;

    if (!transaction.plan_id) {
        return null;
    }

    return (
        <Tooltip.Root>
            <Tooltip.Root>
                <Tooltip.Trigger asChild={true}>
                    <Avatar.Root size="2xs">
                        <Avatar.Fallback aria-label="Recurring icon">
                            <FontAwesomeIcon className={'text-gray-500'} icon={faRepeat} />
                        </Avatar.Fallback>
                    </Avatar.Root>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content className={'!p-3 !py-2'} inverse={true}>
                        <p>Payment from recurring plan</p>
                        <Tooltip.Arrow inverse={true} />
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root>
        </Tooltip.Root>
    );
};

export { TransactionRecurringPlanBadge };
